
import React, { useState, useEffect } from 'react';
import { User, Menu, Phone, PhoneCall } from 'lucide-react';
import { Button } from "./ui/button";
import { Sheet, SheetContent, SheetHeader, SheetTitle, SheetClose } from "./ui/sheet";

const Header = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [isVisible, setIsVisible] = useState(true);
  const [lastScrollY, setLastScrollY] = useState(0);

  useEffect(() => {
    const handleScroll = () => {
      const currentScrollY = window.scrollY;
      
      // Show header when scrolling up or at the top
      if (currentScrollY < lastScrollY || currentScrollY < 10) {
        setIsVisible(true);
      } 
      // Hide header when scrolling down and not at the top
      else if (currentScrollY > lastScrollY && currentScrollY > 100) {
        setIsVisible(false);
      }
      
      setLastScrollY(currentScrollY);
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [lastScrollY]);

  const handlePhoneCall = () => {
    window.location.href = 'tel:+33650429073';
  };

  return (
    <header 
      className={`sticky top-0 z-50 bg-white shadow-sm transition-transform duration-300 ease-in-out ${
        isVisible ? 'translate-y-0' : '-translate-y-full'
      }`}
    >
      <div className="container-custom py-4 flex items-center justify-between">
        {/* Logo */}
        <div className="flex items-center">
          <a href="/" className="flex items-center">
            <span className="text-2xl font-medium font-amaranth text-[#86aa8e]">Ty Gwennili</span>
          </a>
        </div>

        {/* Navigation - Desktop */}
        <div className="hidden md:flex items-center space-x-6">
          <a href="#maison" className="text-sm hover:text-rental-primary transition-colors">La Maison</a>
          <a href="#tarifs" className="text-sm hover:text-rental-primary transition-colors">Tarifs et dates</a>
          <a href="#region" className="text-sm hover:text-rental-primary transition-colors">La Région</a>
          <a href="#contact" className="text-sm hover:text-rental-primary transition-colors">Contact</a>
        </div>

        {/* Contact Button */}
        <div className="flex items-center gap-2">
          <Button variant="ghost" className="hidden sm:flex items-center gap-2" onClick={handlePhoneCall}>
            <PhoneCall className="h-4 w-4" />
            <span>06 50 42 90 73</span>
          </Button>
          
          {/* Mobile Menu Button */}
          <Sheet open={isOpen} onOpenChange={setIsOpen}>
            <div className="border rounded-full p-2 flex items-center gap-3 cursor-pointer hover:shadow-md transition-all md:hidden" onClick={() => setIsOpen(true)}>
              <Menu className="h-5 w-5" />
            </div>
            <SheetContent side="right" className="w-[250px] sm:w-[300px]">
              <SheetHeader className="mb-6">
                <SheetTitle className="text-rental-primary font-amaranth">Ty Gwennili</SheetTitle>
              </SheetHeader>
              <nav className="flex flex-col space-y-4">
                <a href="#maison" className="text-sm hover:text-rental-primary transition-colors py-2 border-b" onClick={() => setIsOpen(false)}>
                  La Maison
                </a>
                <a href="#tarifs" className="text-sm hover:text-rental-primary transition-colors py-2 border-b" onClick={() => setIsOpen(false)}>
                  Tarifs et dates
                </a>
                <a href="#region" className="text-sm hover:text-rental-primary transition-colors py-2 border-b" onClick={() => setIsOpen(false)}>
                  La Région
                </a>
                <a href="#contact" className="text-sm hover:text-rental-primary transition-colors py-2 border-b" onClick={() => setIsOpen(false)}>
                  Contact
                </a>
                <div className="pt-4">
                  <Button variant="ghost" className="flex items-center gap-2 w-full justify-start" onClick={handlePhoneCall}>
                    <PhoneCall className="h-4 w-4" />
                    <span>06 50 42 90 73</span>
                  </Button>
                </div>
              </nav>
            </SheetContent>
          </Sheet>
        </div>
      </div>
    </header>
  );
};

export default Header;
